module.exports = __webpack_public_path__ + "static/media/blobs.868459f4.png";